<script setup lang="ts">
  import { Info } from 'lucide-vue-next';
  import { DIRECTORIES_ACTIONS_PLACEHOLDER_MESSAGE } from '../config/messages';
</script>

<template>
  <div
    data-testid="directories-actions-placeholder"
    class="flex flex-col items-center justify-center px-2 py-8 text-center"
  >
    <div
      class="mb-4 flex size-20 items-center justify-center rounded-full bg-white-02"
    >
      <Info
        class="size-10 text-gray-05"
        :stroke-width="1.5"
        aria-hidden="true"
      />
    </div>
    <p class="max-w-[280px] text-sm text-gray-05">
      {{ DIRECTORIES_ACTIONS_PLACEHOLDER_MESSAGE }}
    </p>
  </div>
</template>
